// extracted by mini-css-extract-plugin
export default {"studio-leaderboard-categories-desc-wrapper":"studio-leaderboard-categories-desc-wrapper_x22Ce"};